import { getRedirectKeywords, getSearchURLSimple } from '.'
import { SEARCH_TYPE } from '../../constant/constant';
export default function navigateToSearchResultsSimple({ value, categoryCode, isCategory, source, enableLWSearchRedirect }) {
  const normalizedSearchTerm = value.toLowerCase().trim()  
  const searchURL = getSearchURLSimple(normalizedSearchTerm, categoryCode, isCategory, source)
  getRedirectKeywords({enableLWSearchRedirect})
    .then(({ keywords, redirectURLs }) => {    
      const searchType = SEARCH_TYPE[source] || "";
      const queryInfo = {
        queryKeyword: value,
        queryType: searchType
      }
      let url = redirectURLs[keywords[normalizedSearchTerm]]

      if (!url) {
        url = searchURL
      } else {
        queryInfo.queryRedirect = url;
      }

      /**
       * Set flag 'search-type' to determine how user entered search.
       * Used in Google Analytics in CQ code.
       */
      fireTagEvent("queryInfo",queryInfo);
      localStorage['search-type'] = searchType;
      window["_satellite"] && _satellite.track && _satellite.track("queryInfo");
      return url
    })
    .then(url => {
      window.location = url
    })
}